import { useEffect, useRef, useState } from "react";
import DeviceApi from "../../../../api/DeviceApi";
import EventManager from "./common/event-manager/EventManager";
import { DeviceMap } from "./component/device-map/DeviceMap";
import { DeviceList } from "./component/device-list/DeviceList";
import { DeivceOnlineDurationWrapper, DeviceAlarmStatisticsWrapper, DeviceAnalyseWrapper, DeviceListWrapper, DeviceMapWrapper, OverviewBigScreenContent, ScreenTitleBar, TractorOverviewInnerWrapper, TractorOverviewWrapper } from "./TractorOverviewScreen.styled";
import ContentCard from "./common/content-card/ContentCard";
import Navigator from "./component/navigator/Navigator";
import TransitionCarousel from "./common/transition-carousel/TransitionCarousel";
import { DeviceAlarmStatistics } from "./component/device-alarm-statistics/DeviceAlarmStatistics";
import DeviceAnalyse from "./component/device-analyse/DeviceAnalyse";
import DeviceOnlineDuration from "./component/device-online-duration/DeviceOnlineDuration";


interface TractorOverviewScreenProps {

}

let TractorOverviewScreen: React.FC<TractorOverviewScreenProps> = () => {
    // api
    let deviceApi = new DeviceApi();

    // event manager
    let eventManagerRef = useRef(new EventManager());

    // state
    let [tractorViews, setTractorViews] = useState<any[]>([]);
    let [selectedTractorView, setSelectedTractorView] = useState<any>(null);
    
    // function
    let refreshTractorViews = async () => {
        let queryResponse = (await deviceApi.queryViews({
            deviceTemplateId: null,
            pageNo: 1, 
            pageSize: 100, 
            productModel: 'QYC',
            search: "",
        })).data.data;
        let tractorViews = queryResponse.elements;
        setTractorViews(tractorViews);
        eventManagerRef.current.notifyDeviceViewsRefresh(tractorViews);
    };

    // effect
    useEffect(() => {
        refreshTractorViews();
        let refreshTask = window.setInterval(()=> {
            refreshTractorViews();
        }, 10 * 1000);
        return () => {
            window.clearInterval(refreshTask);
        };
    }, []);

    // render
    return <TractorOverviewWrapper>
        <TractorOverviewInnerWrapper>
            <ScreenTitleBar>
                <Navigator selected="OVERVIEW"/>
            </ScreenTitleBar>

            <OverviewBigScreenContent>
                <DeviceListWrapper>
                    <ContentCard
                        titleCn="设备列表"
                        titleEn="DEVICE LIST"
                        style={{width: '100%', height: '100%'}}
                    >
                        <DeviceList eventManager={eventManagerRef.current}/>
                    </ContentCard>
                </DeviceListWrapper>

                <DeviceMapWrapper>
                    <DeviceMap eventManager={eventManagerRef.current} />
                </DeviceMapWrapper>

                <DeviceAlarmStatisticsWrapper>
                    <ContentCard
                            titleCn="告警事件"
                            titleEn="ALARMING EVENTS"
                            style={{width: '100%', height: '100%'}}
                        >
                        <DeviceAlarmStatistics />
                    </ContentCard>
                </DeviceAlarmStatisticsWrapper>

                <DeivceOnlineDurationWrapper>
                    <TransitionCarousel switchInterval={10 * 1000} switchOffset={3000} style={{position: 'absolute', zIndex: '100', width: '100%', height: '100%'}}>
                        <ContentCard
                            key="total-online-time"
                            titleCn="设备时长统计"
                            titleEn="DURATION STATISTICS"
                            titleBackgroundHide={true}
                            style={{width: '100%', height: '100%'}}
                        >
                            <DeviceOnlineDuration eventManager={eventManagerRef.current}/>
                        </ContentCard>
                        <ContentCard
                            key="today-online-time"
                            titleCn="今日在线时长"
                            titleEn="DURATION STATISTICS"
                            titleBackgroundHide={true}
                            style={{width: '100%', height: '100%'}}
                        >
                            <DeviceOnlineDuration eventManager={eventManagerRef.current} today={true}/>
                        </ContentCard>
                    </TransitionCarousel>
                </DeivceOnlineDurationWrapper>

                <DeviceAnalyseWrapper>
                    <ContentCard
                            key="overall-analyse"
                            titleCn="数据统计分析"
                            titleEn="STATISTICS ANALYSE"
                            style={{width: '100%', height: '100%'}}
                        >
                        <DeviceAnalyse />
                    </ContentCard>
                </DeviceAnalyseWrapper>
            </OverviewBigScreenContent>
        </TractorOverviewInnerWrapper>
    </TractorOverviewWrapper>
};

export default TractorOverviewScreen;